module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_winter-290d036fb4e867cc90ebad22dacecc8b.jpg";